export default __webpack_public_path__ + "arrow-right.c39d58b86dd002714c30eb1e514506d8.svg";